{
  "audit": {
    "scope": "https://ixicoprod.onmicrosoft.com/a0a6f8c4-663e-4319-b999-6be4f20de390/audit",
    "baseUrl": "https://defaultixi-fde-001-gdfmgta0aje5hxer.a01.azurefd.net/ixiprod/audit"
  },
  "contact": {
    "scope": "https://ixicoprod.onmicrosoft.com/770823d3-f066-42c0-af9a-1c43c5876aca/contact",
    "baseUrl": "https://defaultixi-fde-001-gdfmgta0aje5hxer.a01.azurefd.net/ixiprod/contact"
  },
  "event": {
    "scope": "https://ixicoprod.onmicrosoft.com/cdcd8af8-6993-4f6a-a130-832e67c7fe30/event",
    "baseUrl": "https://defaultixi-fde-001-gdfmgta0aje5hxer.a01.azurefd.net/ixiprod/event"
  },
  "notification": {
    "scope": "https://ixicoprod.onmicrosoft.com/e45d85bc-0414-4ec2-b1ba-564376b8eb3f/notification",
    "baseUrl": "https://defaultixi-fde-001-gdfmgta0aje5hxer.a01.azurefd.net/ixiprod/notification"
  },
  "security": {
    "scope": "https://ixicoprod.onmicrosoft.com/8166e520-bff0-40c6-9c78-e84e9fe09f43/security",
    "baseUrl": "https://defaultixi-fde-001-gdfmgta0aje5hxer.a01.azurefd.net/ixiprod/security"
  },
  "site": {
    "scope": "https://ixicoprod.onmicrosoft.com/32b3db8d-6494-4b7d-a682-68e43029972d/site",
    "baseUrl": "https://defaultixi-fde-001-gdfmgta0aje5hxer.a01.azurefd.net/ixiprod/site"
  },
  "study": {
    "scope": "https://ixicoprod.onmicrosoft.com/0fb9a014-becb-4ac9-8d79-96f96d28f8c0/study",
    "baseUrl": "https://defaultixi-fde-001-gdfmgta0aje5hxer.a01.azurefd.net/ixiprod/study"
  },
  "task": {
    "scope": "https://ixicoprod.onmicrosoft.com/2599995b-598c-435d-99dc-f51c3797f683/task",
    "baseUrl": "https://defaultixi-fde-001-gdfmgta0aje5hxer.a01.azurefd.net/ixiprod/task"
  },
  "forms": {
    "scope": "https://ixicoprod.onmicrosoft.com/772decf3-b876-4ddd-a951-a98b043be552/forms",
    "baseUrl": "https://defaultixi-fde-001-gdfmgta0aje5hxer.a01.azurefd.net/ixiprod/forms"
  },
  "upload": {
    "scope": "https://ixicoprod.onmicrosoft.com/8f2907dd-7cee-4ec8-9795-c32bf6432180/upload",
    "baseUrl": "https://defaultixi-fde-001-gdfmgta0aje5hxer.a01.azurefd.net/ixiprod/upload"
  },
  "cubejs": {
    "scope": "https://ixicoprod.onmicrosoft.com/4f66b128-de63-4cc9-9b3c-aea2c68c41f7/cubejs",
    "baseUrl": "https://defaultixi-fde-001-gdfmgta0aje5hxer.a01.azurefd.net/ixiprod/cubejs"
  }
}
